import { type PillOption } from '@/apps/latest/components/molecules/PillSelect'
import {
  RECORDING_IMAGE_KIND_LABEL,
  type RecordingImageKind,
} from '@/apps/latest/features/attachments/recordingImageApi'

// 薬剤師の系統が資料の部品に渡す値 (置き場・文言・種別は系統が持つ。design-book 04-apps/kakeru.md「資料添付 (薬剤師)」)

// 種別の一覧 (仮。在宅の紙はアイセイに聞いてから足す)。管理栄養士は種別を持たない (design-book ADR-0054 決定 3)。
// 先頭は 未設定 (付けた直後の値。選び直して戻せる)。その他 は「紙だが上の種類でない」と選んだ値
const KINDS: RecordingImageKind[] = [
  'unset',
  'questionnaire',
  'medication_notebook',
  'prescription',
  'remaining_medication',
  'other',
]

export const PHARMACIST_ATTACHMENT_KINDS: PillOption<RecordingImageKind>[] =
  KINDS.map((value) => ({ value, label: RECORDING_IMAGE_KIND_LABEL[value] }))

// 生成中 (音声の送信と SOAP 生成の間・再生成中) に足せない間の 1 行
export const GENERATING_BLOCKED_REASON = 'SOAP ができるまで足せません'
